export const reverseDate = (date) => {
  const d = date.split(' ');
  const day = d[0].split('-').reverse().join('.');
  d.splice(0, 1, day);
  return d.join(' ');
};